<template>
  <!--types:
      char      > text
      decimal   > number
      integer   > number
      boolean   > checkbox
      char list > select | multiselect
      list      > select | multiselect
      json      > form
  -->
  <div>
    <div class="form-group theme-login-form-group extra-form-group">
      <label
        v-if="types.text.indexOf(item.type) !== -1 || types.select.indexOf(item.type) !== -1"
        :for="`field-${item.field}`"
        class="theme-form-label">{{ item.label }}

        <template v-if="item.required !== 'false'">*</template>
        &nbsp;&nbsp;
        <popover-item
          v-if="item.description.length"
          :text="item.description">
          <template slot:default><i class="fa fa-info-circle"></i></template>
        </popover-item>
      </label>
      <!-- TYPE TEXT -->
      <input
        v-if="['char', 'list', 'password'].indexOf(item.type) !== -1"
        :id="`field-${item.field}`"
        :value="field"
        :type="['password'].indexOf(item.type) !== -1 ? 'password' : 'text'"
        :name="item.field"
        :class="{ 'alert-danger': submitted && errors.has(item.field) }"
        :readonly="Object.prototype.hasOwnProperty.call(item, 'readonly') ? true : false"
        v-validate="(item.required !== 'false') ? 'required' : ''"
        :data-vv-name="item.field"
        :ref="item.field"
        :maxlength="item.max_length"
        class="form-control"
        @input="$emit('update:field', $event.target.value)" />
      <!-- // TYPE TEXT -->
      <!-- TYPE DECIMAL OR INTEGER -->
      <input
        v-if="['decimal', 'integer'].indexOf(item.type) !== -1"
        :id="`field-${item.field}`"
        :value="field"
        type="number"
        :name="item.field"
        :class="{ 'alert-danger': submitted && errors.has(item.field) }"
        :readonly="Object.prototype.hasOwnProperty.call(item, 'readonly') ? true : false"
        v-validate="(item.required !== 'false') ? 'required' : ''"
        :data-vv-name="item.field"
        :ref="item.field"
        :maxlength="item.max_length"
        class="form-control"
        @input="$emit('update:field', $event.target.value)" />
      <!-- // TYPE DECIMAL OR INTEGER -->
      <!-- TYPE TEL -->
      <the-mask
        v-if="['tel'].indexOf(item.type) !== -1"
        :id="`field-${item.field}`"
        v-model="modelField"
        :name="item.field"
        :class="{ 'alert-danger': submitted && errors.has(item.field) }"
        :mask="['(##) ####-####', '(##) #####-####']"
        v-validate="(item.required !== 'false') ? 'required' : ''"
        :data-vv-name="item.field"
        :ref="item.field"
        :readonly="Object.prototype.hasOwnProperty.call(item, 'readonly') ? true : false"
        class="form-control"
        type="text" />
      <!-- // TYPE TEL -->
      <!-- TYPE CHECKBOX -->
      <div
        v-if="['boolean'].indexOf(item.type) !== -1"
        class="mt-20">
        <p-check
          v-model="modelField"
          :name="item.field"
          :value="item.value"
          :checked="item.value"
          :disabled="item.hasOwnProperty('readonly') ? item.readonly : false"
          v-validate="(item.required !== 'false') ? 'required:true' : ''"
          :class="{ 'mb-30': item.description.length === 0 }"
          class="p-default p-curve p-fill p-smooth mt-5 clearfix"
          color="primary">
          <strong>
            {{ item.label }}
            <template v-if="item.required !== 'false'">*</template>
          </strong>
        </p-check>
        <div
          v-if="item.description.length"
          class="mt-5"><i class="fa fa-info-circle btn-link"></i> {{ item.description }}</div>
      </div>
      <!-- // TYPE CHECKBOX -->
      <!-- TYPE SELECT -->
      <multiselect
        v-if="['char list'].indexOf(item.type) !== -1"
        v-model="multiselect[item.field]"
        :options="item.options"
        :multiple="false"
        :close-on-select="true"
        :clear-on-select="false"
        :name="item.field"
        :placeholder="(item.value) ? item.value : 'Selecione'"
        :class="{ 'has-error': submitted && errors.has(item.field) }"
        :disabled="Object.prototype.hasOwnProperty.call(item, 'readonly') ? true : false"
        v-validate="(item.required !== 'false') ? 'required' : ''"
        track-by="value"
        label="title"
        selectedLabel="Selecionado"
        selectLabel="Clique para selecionar"
        deselectLabel="Clique para desmarcar seleção"
        @input="handleOptions(item.field)">
        <template
          slot="selection"
          slot-scope="{ values, search, isOpen }">
          <span
            class="form-control"
            v-if="values.length &amp;&amp; !isOpen">
            {{ values.length }} selecionados
          </span>
        </template>
      </multiselect>
      <!-- // TYPE SELECT -->
      <span
        v-if="submitted && errors.has(item.field)"
        class="theme-form-error-message">{{ errors.first(item.field) }}</span>
    </div>
  </div>
</template>

<script>
import PopoverItem from '@/components/ui/PopoverItem'
import Multiselect from 'vue-multiselect'

export default {
  inject: ['$validator'],
  components: {
    PopoverItem,
    Multiselect
  },
  props: [
    'item',
    'field',
    'submitted',
    'types'
  ],
  data () {
    return {
      multiselect: {},
      modelField: null
    }
  },
  mounted () {
    this.handleModelField(this.item.value)
  },
  watch: {
    modelField (data) {
      this.$emit('update:field', data)
    },
    field (data) {
      this.handleModelField(data)
    }
  },
  methods: {
    handleModelField (value) {
      if (['tel', 'boolean'].indexOf(this.item.type) !== -1) {
        this.modelField = value
      }
    },
    handleOptions (field) {
      if (this.multiselect[field].length) {
        this.$emit('update:field', this.multiselect[field].map(option => option.value).join(','))
      } else {
        this.$emit('update:field', this.multiselect[field].value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';
@import '@/scss/components/forms/MultiselectField';
</style>
